import React from 'react';
import { useI18next } from 'gatsby-plugin-react-i18next';
import PostThumbnail from '@components/PlaysAndPlaybooks/PlayThumbnail';
import * as styles from './style.module.scss';

const {
  playGridItems,
  playGridItems__grid,
  playGridItems__featured,
  playGridItems__gridWrap,
  playGridItems__gridItemsTwo,
} = styles;

const GridItems = ({ posts }) => {
  const { language } = useI18next();

  return (
    <section className={`${playGridItems}`}>
      <div className={`${playGridItems__grid}`}>
        <div className={`${playGridItems__featured}`}>
          <div
            className={`${playGridItems__gridWrap} ${
              posts && posts.length === 2 ? playGridItems__gridItemsTwo : ''
            }`}
          >
            {posts &&
              posts.map((item) => (
                <PostThumbnail
                  key={item.id}
                  post={item}
                  classModifier="filters"
                  showPostType={false}
                  playTypeLabel={
                    language === 'de'
                      ? item.playType
                      : item.playType.toLowerCase()
                  }
                />
              ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default GridItems;
